/* MIIM.MIIC — New Arrivals landing page behaviour */
(function () {
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      var base = add.dataset.base || add.textContent;
      add.dataset.base = base;
      add.classList.add('added');
      add.textContent = 'ADDED \u2713';
      clearTimeout(add._t);
      add._t = setTimeout(function () {
        add.classList.remove('added');
        add.textContent = base;
      }, 1800);
      return;
    }
    var faq = e.target.closest('[data-faq]');
    if (faq) faq.classList.toggle('open');
  });

  var reveals = document.querySelectorAll('.reveal,.reveal-grid');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.05 });
    reveals.forEach(function (n) { io.observe(n); });
  } else {
    reveals.forEach(function (n) { n.classList.add('in'); });
  }
})();
